/**
 *  Shop the look
 *  ---------------------------------------------------------------------------
 *  Hotspot-Dots auf einem Bild. Klick öffnet ein Popup mit Produktbild,
 *  Titel, Preis und Link zum verlinkten Produkt. Bedienung 1:1 wie
 *  Academy Our Bikes (academy-our-bikes.js).
 *
 *  Optional (section.settings.parallax → [data-stl-parallax]):
 *  das Bild bekommt einen sanften, scroll-gekoppelten yPercent-Versatz
 *  (GSAP ScrollTrigger, scrub) — analog zu Academy Image + Text.
 */
(function () {
  var CLOSE_DURATION = 180;
  var REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Hotspots / Popups ─────────────────────────────────────── */
  function closeHotspot(hotspot) {
    hotspot.classList.add('is-closing');
    setTimeout(function () {
      hotspot.classList.remove('is-active', 'is-closing');
    }, CLOSE_DURATION);
  }

  function closeAllHotspots() {
    document.querySelectorAll('.shop-the-look__hotspot.is-active').forEach(closeHotspot);
  }

  function positionPopup(hotspot) {
    var popup = hotspot.querySelector('[data-hotspot-popup]');
    if (!popup) return;

    var dot = hotspot.querySelector('[data-hotspot-toggle]');
    var stage = hotspot.closest('.shop-the-look__stage');
    var dotSize = dot ? dot.offsetWidth : 48;
    var popupWidth = 400;
    var gap = 16;

    var hotspotRect = hotspot.getBoundingClientRect();
    var stageRect = stage
      ? stage.getBoundingClientRect()
      : { left: 0, top: 0, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight };

    // Mobile: innerhalb der Stage zentrieren
    if (window.innerWidth < 1024) {
      var mobileWidth = Math.min(360, window.innerWidth - 32);
      popup.style.width = mobileWidth + 'px';
      popup.style.left = (stageRect.left - hotspotRect.left + (stageRect.width - mobileWidth) / 2) + 'px';
      popup.style.top  = (stageRect.top  - hotspotRect.top  + stageRect.height / 2 - 150) + 'px';
      popup.style.transformOrigin = 'top center';
      return;
    }

    popup.style.width = '';

    // Desktop: standardmäßig rechts vom Dot
    var left = dotSize + gap;
    var top  = -30;

    // Nach links kippen, wenn das Popup rechts über die Stage ragt
    if (hotspotRect.left + left + popupWidth > stageRect.right - gap) {
      left = -(popupWidth + gap);
      popup.style.transformOrigin = 'top right';
    } else {
      popup.style.transformOrigin = 'top left';
    }

    // Vertikal in der Stage halten
    var minTop = stageRect.top - hotspotRect.top + gap;
    if (top < minTop) top = minTop;

    popup.style.left = left + 'px';
    popup.style.top  = top  + 'px';
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-hotspot-toggle]');
    var close  = e.target.closest('[data-hotspot-close]');

    if (close) {
      var closeHost = close.closest('.shop-the-look__hotspot');
      if (closeHost) closeHotspot(closeHost);
      return;
    }

    if (toggle) {
      var hotspot   = toggle.closest('.shop-the-look__hotspot');
      var wasActive = hotspot.classList.contains('is-active');

      closeAllHotspots();

      if (!wasActive) {
        positionPopup(hotspot);
        hotspot.classList.add('is-active');
      }
      return;
    }

    if (!e.target.closest('.shop-the-look__popup')) {
      closeAllHotspots();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllHotspots();
  });

  /* ── Parallax ──────────────────────────────────────────────── */
  function setupParallax() {
    if (REDUCE_MOTION) return;
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) return;

    document.querySelectorAll('[data-stl-parallax]').forEach(function (wrap) {
      var imgs = wrap.querySelectorAll('.shop-the-look__img');
      if (!imgs.length) return;

      var amount = parseFloat(wrap.getAttribute('data-stl-parallax-amount')) || 12;
      var headroom = 1 + (amount * 2) / 100;

      wrap.classList.add('is-parallax-ready');

      imgs.forEach(function (img) {
        gsap.fromTo(
          img,
          { yPercent: -amount, scale: headroom },
          {
            yPercent: amount,
            scale: headroom,
            ease: 'none',
            scrollTrigger: {
              trigger: wrap,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1
            }
          }
        );
      });
    });
  }

  if (document.readyState !== 'loading') {
    setupParallax();
  } else {
    document.addEventListener('DOMContentLoaded', setupParallax);
  }
})();

/**
 *  @class ShopTheLook
 */
if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {}
  }
  customElements.define('shop-the-look', ShopTheLook);
}
